import { render, staticRenderFns } from "./SlideshowStickyPost.vue?vue&type=template&id=53b02660&scoped=true"
import script from "./SlideshowStickyPost.vue?vue&type=script&lang=js"
export * from "./SlideshowStickyPost.vue?vue&type=script&lang=js"
import style0 from "./SlideshowStickyPost.vue?vue&type=style&index=0&id=53b02660&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b02660",
  null
  
)

export default component.exports